module.exports = __webpack_public_path__ + "static/media/iiitbbsr.1a5a338c.jpg";